import { render } from "./CCommonDialogComponent.vue?vue&type=template&id=3ff6cf45&scoped=true"
import script from "./CCommonDialogComponent.vue?vue&type=script&lang=js"
export * from "./CCommonDialogComponent.vue?vue&type=script&lang=js"

import "./CCommonDialogComponent.vue?vue&type=style&index=0&id=3ff6cf45&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff6cf45"]])

export default __exports__